import { LinearProgress } from '@mui/material'
import React from 'react'
import { Colors } from '../../../theme/colors'

const sizeDertermination = (size: Size) => {
    switch (size) {
        case 'sm':
            return 1
        case 'md':
            return 1.2
        case 'lg':
            return 1.4
        case 'xl':
            return 2
    }
}

const colorDynamicPicker = (color: string, size: Size) => {
    const WIDTH = 113
    const HEIGHT = 57
    const sizeFactor = sizeDertermination(size)
    const calculatedWidth = WIDTH * sizeFactor
    const calculatedHeight = HEIGHT * sizeFactor
    return (
        <svg
            width={String(calculatedWidth)}
            height={String(calculatedHeight)}
            viewBox="0 0 113 57"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M25.1621 35.8379H32.1445C31.9583 38.3092 31.2728 40.5013 30.0879 42.4141C28.903 44.3099 27.2526 45.7995 25.1367 46.8828C23.0208 47.9661 20.4564 48.5078 17.4434 48.5078C15.1243 48.5078 13.0339 48.1016 11.1719 47.2891C9.32682 46.4596 7.74414 45.2832 6.42383 43.7598C5.12044 42.2194 4.12174 40.3743 3.42773 38.2246C2.73372 36.0579 2.38672 33.6289 2.38672 30.9375V28.1191C2.38672 25.4277 2.74219 22.9987 3.45312 20.832C4.16406 18.6654 5.17969 16.8203 6.5 15.2969C7.83724 13.7565 9.43685 12.5716 11.2988 11.7422C13.1777 10.9128 15.2767 10.498 17.5957 10.498C20.6087 10.498 23.1562 11.0566 25.2383 12.1738C27.3203 13.2741 28.9368 14.7891 30.0879 16.7188C31.2389 18.6484 31.9329 20.8659 32.1699 23.3711H25.1875C25.0521 21.8138 24.7135 20.4935 24.1719 19.4102C23.6471 18.3268 22.8516 17.5059 21.7852 16.9473C20.7357 16.3717 19.3392 16.084 17.5957 16.084C16.2415 16.084 15.0482 16.3379 14.0156 16.8457C13 17.3535 12.1536 18.1152 11.4766 19.1309C10.7995 20.1296 10.2917 21.3822 9.95312 22.8887C9.61458 24.3783 9.44531 26.1048 9.44531 28.0684V30.9375C9.44531 32.8164 9.59766 34.5007 9.90234 35.9902C10.207 37.4798 10.681 38.7409 11.3242 39.7734C11.9674 40.806 12.7969 41.5931 13.8125 42.1348C14.8281 42.6764 16.0384 42.9473 17.4434 42.9473C19.153 42.9473 20.541 42.6764 21.6074 42.1348C22.6908 41.5931 23.5117 40.7975 24.0703 39.748C24.6458 38.6986 25.0098 37.3952 25.1621 35.8379ZM52.6602 11.0312V48H45.7031V11.0312H52.6602ZM64.1367 11.0312V16.541H34.3535V11.0312H64.1367ZM68.7832 11.0312H82.2148C85.0247 11.0312 87.4368 11.4544 89.4512 12.3008C91.4655 13.1471 93.0143 14.3997 94.0977 16.0586C95.181 17.7174 95.7227 19.7572 95.7227 22.1777C95.7227 24.0905 95.3841 25.7493 94.707 27.1543C94.0299 28.5592 93.0736 29.7357 91.8379 30.6836C90.6191 31.6315 89.1803 32.3763 87.5215 32.918L85.3379 34.0352H73.4805L73.4297 28.5254H82.291C83.7298 28.5254 84.9232 28.2715 85.8711 27.7637C86.819 27.2559 87.5299 26.5534 88.0039 25.6562C88.4948 24.7591 88.7402 23.735 88.7402 22.584C88.7402 21.3483 88.5033 20.2819 88.0293 19.3848C87.5553 18.4707 86.8359 17.7682 85.8711 17.2773C84.9062 16.7865 83.6875 16.541 82.2148 16.541H75.7656V48H68.7832V11.0312ZM89.6543 48L81.0977 31.4453L88.4863 31.4199L97.1445 47.6445V48H89.6543Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M105.512 39.8329C106.837 39.8919 107.843 38.5892 109.154 38.5519C110.274 38.4982 111.337 39.0326 111.945 39.9541C111.972 39.9952 112.025 40.0111 112.071 39.9919C112.117 39.9726 112.142 39.9237 112.13 39.8764C111.827 38.609 111.14 37.4611 110.158 36.5838C107.411 34.1928 104.668 35.2189 104.668 35.2189C103.664 35.5699 103.006 36.5165 103.042 37.5601C103.08 38.8628 104.163 39.7987 105.512 39.8329Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M106.524 42.2116C105.797 43.2888 106.444 44.7742 105.816 45.8943C105.294 46.8561 104.275 47.4795 103.141 47.5301C103.09 47.5314 103.047 47.5687 103.041 47.6174C103.036 47.6661 103.069 47.7113 103.118 47.7234C104.405 48.0984 105.781 48.0919 107.064 47.705C110.602 46.5971 111.081 43.7952 111.081 43.7952C111.277 42.7826 110.765 41.765 109.814 41.2787C108.627 40.6649 107.241 41.1038 106.524 42.2147"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M104.69 42.5119C104.041 41.3886 102.283 41.1857 101.545 40.123C100.903 39.2232 100.841 38.0859 101.383 37.1346C101.402 37.0934 101.388 37.0456 101.348 37.019C101.308 36.9924 101.252 36.9939 101.214 37.0225C100.182 37.8849 99.4662 39.0071 99.1612 40.2411C98.3631 43.6745 100.788 45.4428 100.788 45.4428C101.653 46.1011 102.894 46.1843 103.859 45.6486C105.046 44.9773 105.415 43.5794 104.69 42.5028"
                fill={color}
            />
        </svg>
    )
}

type Size = 'sm' | 'md' | 'lg' | 'xl'
type Props = {
    size?: Size
    color?: keyof typeof Colors
}

const styles: React.CSSProperties = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '100px',
}

export default function CTRLoader({ size = 'lg', color = 'purple_3500a0' }: Props) {
    return (
        <div style={styles}>
            {colorDynamicPicker(Colors[color], size)}
            <span style={{ marginBottom: '20px' }} />
            <LinearProgress style={{ padding: '0.1rem', color: Colors[color] }} />
        </div>
    )
}
